module.exports = __webpack_public_path__ + "static/media/ten_-monkeys.a933eeab.png";